export const colors = {
  yellow: "#FFE532",
  grey: "#1C202399",
  shadowGrey: "#0010521A",
  lightGrey: "#F2F3F7",
  darkGrey: "#636974",
  white: "#FFF",
  lightBlack: "#1C2023",
  black: "#000",
  blue: "#357BF7",
  lightBlue: "",
  lightRed: "",
  red: "#D7373F",
  paleGray: "#D7DAE3",
  darkPurple: "#0B0A36",
}

export const colorsBeeline = {
  black: "#191C22",
  lightBlack: "#727281",
}
